import { createGlobalStyle } from 'styled-components';

const HiddenIframe = createGlobalStyle`
  iframe[style="position: fixed; top: 0px; left: 0px; width: 100%; height: 100%; border: none; z-index: 2147483647;"] {
    display: none;
  }
`;

export const CypressModalHider = () => <HiddenIframe />;
